var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturesIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 41,
    viewBox: "0 0 39 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3044 30.4409C31.4198 31.9349 30.5502 33.1488 30.0587 34.4C29.7751 35.1284 29.5293 35.8754 29.1701 36.5477C28.6786 37.4628 29.208 38.1724 29.5293 38.9195C29.586 39.0689 29.9452 39.1436 30.1721 39.1436C30.777 39.1809 31.3631 39.1622 31.968 39.1622C32.6486 39.1622 33.4236 39.1622 33.4425 40.0586C33.4615 40.9551 32.7242 41.0111 32.0247 40.9924C31.3631 40.9924 30.7014 40.9924 30.0398 40.9924C22.1377 40.9924 14.2168 40.9924 6.3147 40.9924C5.59634 40.9924 4.76454 41.1418 4.63221 40.1147C4.53769 39.4424 5.08592 39.1622 6.35251 39.1622C6.59827 39.1622 6.86293 39.1622 7.10869 39.1622C8.77228 39.1622 9.50955 38.0604 8.8857 36.4917C8.50762 35.5766 8.09172 34.6615 7.78925 33.7091C7.50568 32.8313 7.35445 31.9349 7.08978 30.8704C5.91771 30.8704 4.44317 30.8704 2.96862 30.8704C2.36368 30.8704 1.77764 30.8704 1.1727 30.8704C0.529951 30.8704 0.0195312 30.6837 0.0195312 29.9553C0.0195312 29.227 0.548855 29.0402 1.19161 29.0402C2.51491 29.0402 3.83822 29.0589 5.16153 29.0402C6.20128 29.0216 7.46787 29.3204 8.18624 28.8535C8.8857 28.4053 9.01804 27.1167 9.37722 26.2016C10.6249 23.0268 11.797 19.796 13.177 16.6586C13.7441 15.3886 13.8387 14.1561 13.9899 12.8488C14.1033 11.8217 13.9899 10.9066 13.8576 9.91678C13.6307 8.23601 14.2168 6.81669 15.4266 5.6028C15.6913 5.34135 15.8425 4.87446 15.8992 4.50096C15.9749 3.97805 15.8992 3.43647 15.9371 2.91356C16.0127 1.25147 17.2982 0.0188979 18.924 0.000222671C20.5686 -0.0184526 21.8541 1.13941 22.0054 2.78284C22.0243 2.96959 22.0432 3.15634 22.0243 3.34309C21.9298 4.42626 22.1566 5.304 22.9884 6.18173C24.2361 7.47033 24.4251 9.1511 23.9147 10.9066C23.8202 11.2614 23.9525 11.6723 23.9903 12.0644C24.0281 12.3632 24.1416 12.6807 24.1227 12.9795C24.1038 14.1934 24.2739 15.2953 24.7843 16.4531C26.3912 20.1695 27.809 23.9606 29.2647 27.733C29.5104 28.3866 29.8129 28.6294 30.5502 28.6107C32.4973 28.5547 34.4634 28.592 36.4105 28.592C37.11 28.592 38.0363 28.424 38.0363 29.4885C38.0363 30.609 37.0911 30.4409 36.3538 30.4409C34.4067 30.4409 32.4595 30.4409 30.3044 30.4409ZM10.4926 39.0689C16.2584 39.0689 21.8352 39.0689 27.5633 39.0689C26.4857 36.3236 25.4649 33.6904 24.3873 31.0758C24.2739 30.7957 23.8958 30.4409 23.6501 30.4596C23.064 30.4969 22.3835 30.0861 21.9109 30.9264C20.6632 33.1675 17.9598 33.3356 16.353 31.356C16.2017 31.1506 15.956 30.9264 15.7291 30.8891C14.1222 30.5903 13.763 30.8144 13.1581 32.3084C12.7422 33.3542 12.3263 34.3814 11.9104 35.4272C11.4567 36.6037 10.9841 37.7803 10.4926 39.0689ZM14.5192 28.9095C15.3321 29.1523 15.7669 29.0589 16.0694 28.2559C16.4853 27.0793 17.4494 26.4257 18.716 26.3137C20.0582 26.2016 21.1736 26.6872 21.7974 27.8637C22.1755 28.5547 22.5725 28.7228 23.3665 28.4613C21.9487 24.857 20.5308 21.29 19.0374 17.5176C17.4683 21.4394 16.0127 25.1371 14.5192 28.9095ZM18.924 11.5789C19.4533 11.5789 20.0015 11.5229 20.5308 11.5976C21.4004 11.7283 21.7974 11.2614 22.0621 10.5704C22.6103 9.2258 22.1944 7.69443 21.0602 6.79802C19.9259 5.9016 18.3946 5.80823 17.1847 6.57391C15.956 7.3396 15.3699 8.83362 15.748 10.2156C16.0505 11.3361 16.3908 11.5789 17.5817 11.5976C18.0354 11.5789 18.4892 11.5789 18.924 11.5789ZM17.1658 17.1441C16.7499 17.1254 16.4853 17.1254 16.2584 17.0881C15.2376 16.9013 14.765 17.3682 14.4436 18.302C13.7441 20.3002 12.9123 22.2425 12.1562 24.222C11.5512 25.7721 10.9463 27.3408 10.3035 28.9842C10.6627 29.0029 10.9085 29.0216 11.1353 29.0589C12.1184 29.2083 12.6477 28.8908 12.9691 27.8824C13.5929 26.0335 14.3869 24.222 15.1053 22.4105C15.7669 20.6737 16.4286 18.9743 17.1658 17.1441ZM20.8522 17.0881C22.2133 20.5057 23.4799 23.7178 24.7465 26.9113C25.4649 28.7228 25.4649 28.7228 27.6011 28.5173C26.1454 24.8196 24.7087 21.1593 23.2531 17.4989C23.1774 17.3122 22.9128 17.1254 22.7048 17.1068C22.1566 17.0507 21.5895 17.0881 20.8522 17.0881ZM15.8047 15.1645C18.0165 15.1645 20.1149 15.1645 22.2322 15.1645C22.2322 14.5669 22.2322 14.0627 22.2322 13.4838C20.0771 13.4838 17.9598 13.4838 15.8047 13.4838C15.8047 14.0627 15.8047 14.5856 15.8047 15.1645ZM26.1454 30.4409C26.7315 31.9162 27.2797 33.2609 27.8846 34.7922C28.2627 33.8585 28.5841 33.1488 28.8488 32.4205C29.0945 31.7295 28.5463 30.4969 27.9792 30.4596C27.3931 30.4035 26.8449 30.4409 26.1454 30.4409ZM19.0374 28.1252C18.3001 28.1252 17.6385 28.7414 17.6195 29.4698C17.6195 30.1981 18.2434 30.8331 18.9996 30.8331C19.7557 30.8331 20.3985 30.2355 20.3985 29.4885C20.4174 28.7788 19.7747 28.1438 19.0374 28.1252ZM10.1712 34.7922C10.7194 33.3729 11.192 32.1777 11.7214 30.8517C11.2109 30.8517 10.8329 30.8517 10.4548 30.8517C9.3016 30.8517 8.8668 31.5054 9.2827 32.5885C9.52845 33.2609 9.81202 33.9145 10.1712 34.7922ZM17.8086 4.23951C18.6026 4.23951 19.3398 4.23951 20.1338 4.23951C20.1716 3.45515 20.4552 2.57741 19.5856 2.0545C19.2831 1.86775 18.6782 1.86775 18.3568 2.0545C17.4683 2.55873 17.8275 3.45515 17.8086 4.23951Z",
    fill: "url(#paint0_linear_1784_3973)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5156 22.149C32.5156 20.3935 33.9524 18.9368 35.7294 18.9181C37.5442 18.8995 39.0187 20.3748 38.9998 22.1863C38.9809 23.9418 37.5253 25.3798 35.7483 25.3798C33.9902 25.3611 32.5345 23.9044 32.5156 22.149ZM37.1472 22.1303C37.1472 21.3833 36.5045 20.767 35.7483 20.767C35.011 20.767 34.3872 21.402 34.3872 22.149C34.3872 22.896 35.0299 23.5309 35.7672 23.5123C36.5234 23.5123 37.1661 22.8586 37.1472 22.1303Z",
    fill: "url(#paint1_linear_1784_3973)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39343 11.5417C7.41233 13.0731 6.12683 14.343 4.57667 14.3243C3.06431 14.3057 1.81662 13.0918 1.81662 11.5791C1.79772 10.0851 3.0265 8.83382 4.53886 8.79647C6.07012 8.75912 7.37452 10.0104 7.39343 11.5417ZM5.89998 11.5044C5.27613 11.1122 4.89804 10.6827 4.59557 10.72C4.25529 10.776 3.78268 11.2243 3.72597 11.5604C3.63145 12.102 4.08515 12.5502 4.65229 12.4381C5.01147 12.3821 5.31394 11.9713 5.89998 11.5044Z",
    fill: "url(#paint2_linear_1784_3973)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.6264C0 21.0475 0 20.4873 0 19.8896C1.20988 19.8896 2.38196 19.8896 3.59184 19.8896C3.59184 20.4873 3.59184 21.0288 3.59184 21.6264C2.40086 21.6264 1.22879 21.6264 0 21.6264Z",
    fill: "url(#paint3_linear_1784_3973)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3842 4.16466C32.1554 4.16466 31.0022 4.16466 29.7734 4.16466C29.7734 3.58572 29.7734 3.04414 29.7734 2.44653C30.9644 2.44653 32.1365 2.44653 33.3842 2.44653C33.3842 2.98812 33.3842 3.5297 33.3842 4.16466Z",
    fill: "url(#paint4_linear_1784_3973)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63281 19.8708C5.25666 19.8708 5.80489 19.8708 6.40983 19.8708C6.40983 20.4685 6.40983 21.01 6.40983 21.6076C5.8427 21.6076 5.27556 21.6076 4.63281 21.6076C4.63281 21.0661 4.63281 20.5245 4.63281 19.8708Z",
    fill: "url(#paint5_linear_1784_3973)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2001 2.46558C36.2001 3.00716 36.2001 3.53007 36.2001 4.12767C35.633 4.12767 35.1037 4.12767 34.4609 4.12767C34.4609 3.62344 34.4609 3.08186 34.4609 2.46558C35.0092 2.46558 35.5763 2.46558 36.2001 2.46558Z",
    fill: "url(#paint6_linear_1784_3973)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05696 7.07798C8.8112 6.74182 8.33859 6.36832 8.39531 6.10686C8.47092 5.75203 8.92463 5.28515 9.26491 5.21045C9.51067 5.15442 10.0967 5.71468 10.1156 6.01349C10.1345 6.34964 9.69971 6.72315 9.47286 7.09665C9.32162 7.09665 9.18929 7.07798 9.05696 7.07798Z",
    fill: "url(#paint7_linear_1784_3973)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44022 36.5291C3.21337 36.1556 2.77857 35.7821 2.79747 35.4273C2.81638 35.1285 3.3457 34.6429 3.66708 34.6243C3.96955 34.6243 4.49887 35.1285 4.51777 35.4273C4.53668 35.7821 4.12078 36.1556 3.87502 36.5291C3.72379 36.5291 3.59146 36.5291 3.44022 36.5291Z",
    fill: "url(#paint8_linear_1784_3973)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0104 36.5289C35.7835 36.1741 35.4244 35.8379 35.3676 35.4644C35.292 34.8855 35.7457 34.456 36.294 34.6054C36.6342 34.6987 37.069 35.1843 37.0879 35.5204C37.1069 35.8379 36.6531 36.1927 36.3885 36.5289C36.2562 36.5289 36.1427 36.5289 36.0104 36.5289Z",
    fill: "url(#paint9_linear_1784_3973)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3514 9.03906C35.9734 9.26317 35.5953 9.6927 35.2361 9.65535C34.9336 9.63667 34.4988 9.13244 34.4232 8.77761C34.3098 8.21735 34.7824 7.82517 35.3495 7.91855C35.7087 7.99325 36.0301 8.38543 36.3514 8.62821C36.3703 8.77761 36.3703 8.90834 36.3514 9.03906Z",
    fill: "url(#paint10_linear_1784_3973)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7724 13.0356C29.2072 13.6333 29.6609 13.9694 29.642 14.2869C29.6231 14.623 29.1883 15.1086 28.848 15.1833C28.2809 15.3327 27.8272 14.8845 27.9028 14.3242C27.9406 13.9694 28.3376 13.6519 28.7724 13.0356Z",
    fill: "url(#paint11_linear_1784_3973)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91744 25.3243C5.3125 25.7725 4.99113 26.1646 4.63194 26.2207C4.06481 26.314 3.6111 25.8658 3.72453 25.3243C3.80015 24.9881 4.29166 24.5586 4.63194 24.5025C4.93441 24.4839 5.2936 24.9134 5.91744 25.3243Z",
    fill: "url(#paint12_linear_1784_3973)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2429 33.5037C19.4697 33.8585 19.9045 34.232 19.8667 34.5495C19.8289 34.8856 19.3752 35.3712 19.0349 35.4272C18.4867 35.5206 18.033 35.0911 18.1464 34.5121C18.222 34.1386 18.6001 33.8398 18.8459 33.5037C18.9782 33.5037 19.1106 33.5037 19.2429 33.5037Z",
    fill: "url(#paint13_linear_1784_3973)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2229 36.2863C19.4497 36.6224 19.9035 36.9772 19.8656 37.2947C19.8278 37.6309 19.393 38.1164 19.0528 38.1725C18.5045 38.2845 18.0508 37.8737 18.1453 37.276C18.2021 36.9025 18.5801 36.6037 18.8259 36.2676C18.9582 36.2863 19.0906 36.2863 19.2229 36.2863Z",
    fill: "url(#paint14_linear_1784_3973)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1784_3973",
    x1: 19.0279,
    y1: 0,
    x2: 19.0279,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1784_3973",
    x1: 35.7578,
    y1: 18.918,
    x2: 35.7578,
    y2: 25.3798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1784_3973",
    x1: 4.60502,
    y1: 8.79565,
    x2: 4.60502,
    y2: 14.3245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1784_3973",
    x1: 1.79592,
    y1: 19.8896,
    x2: 1.79592,
    y2: 21.6264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1784_3973",
    x1: 31.5788,
    y1: 2.44653,
    x2: 31.5788,
    y2: 4.16466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1784_3973",
    x1: 5.52132,
    y1: 19.8708,
    x2: 5.52132,
    y2: 21.6076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1784_3973",
    x1: 35.3305,
    y1: 2.46558,
    x2: 35.3305,
    y2: 4.12767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1784_3973",
    x1: 9.25341,
    y1: 5.20654,
    x2: 9.25341,
    y2: 7.09665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1784_3973",
    x1: 3.65764,
    y1: 34.6243,
    x2: 3.65764,
    y2: 36.5291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1784_3973",
    x1: 36.2239,
    y1: 34.5754,
    x2: 36.2239,
    y2: 36.5289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1784_3973",
    x1: 35.3859,
    y1: 7.90479,
    x2: 35.3859,
    y2: 9.65763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1784_3973",
    x1: 28.7686,
    y1: 13.0356,
    x2: 28.7686,
    y2: 15.2123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1784_3973",
    x1: 4.81224,
    y1: 24.502,
    x2: 4.81224,
    y2: 26.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1784_3973",
    x1: 18.999,
    y1: 33.5037,
    x2: 18.999,
    y2: 35.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1784_3973",
    x1: 19.0003,
    y1: 36.2676,
    x2: 19.0003,
    y2: 38.1909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#FE5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesIcon01);
export default __webpack_public_path__ + "static/media/features_icon01.7a614367f83f8de91691a124e6c0bb78.svg";
export { ForwardRef as ReactComponent };